import { Box, Button, Column, Flex, Row, Text } from '@atom-web/micros'

import DisplayPrice from '../DisplayPrice'

function Pricecomponent({
	strikedCost,
	startsAtPrice,
	onPress,
	displayCurrency,
	currentResortCode,
	paxCount,
}) {
	const perPersonPrice = startsAtPrice / paxCount
	const offerPercentage = Math.round(
		((strikedCost - startsAtPrice) / strikedCost) * 100,
	)
	return (
		<Box
			css={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'flex-end',
				alignItems: 'flex-end',
				gap: '8px',
				flex: 1,
				'@lg': {
					flexDirection: 'column',
					alignItems: 'center',
				},
			}}
		>
			<Column
				css={{
					alignItems: 'flex-end',
					'@lg': { marginTop: '$7', alignItems: 'center' },
				}}
			>
				{offerPercentage >= 7 ? (
					<Row css={{ alignItems: 'center', gap: '8px' }}>
						<Text
							css={{
								fontSize: '$2',
								textDecorationLine: 'line-through',
								color: '$grey05',
								fontWeight: '$bold',
								marginLeft: '$1',
							}}
						>
							<DisplayPrice
								objectData={{ value: strikedCost }}
								path={'value'}
								defaultValue="0"
								reduxCurrency={displayCurrency}
							/>
						</Text>
						<Flex
							css={{
								backgroundColor: '#F3205F',
								padding: '1px 7px',
								borderRadius: '22px',
								boxSizing: 'border-box',
							}}
						>
							<Text
								css={{
									fontSize: '12px',
									color: '$white',
									fontWeight: '$bold',
									lineHeight: '18px',
								}}
							>
								{`${offerPercentage}% off`}
							</Text>
						</Flex>
					</Row>
				) : null}
				<Text
					css={{
						color: '$grey12',
						fontWeight: '$extrabold',
						fontSize: '20px',
						lineHeight: '28px',
						'@lg': {
							fontSize: '24px',
							lineHeight: '28px',
						},
					}}
				>
					<DisplayPrice
						objectData={{ value: startsAtPrice }}
						path={'value'}
						defaultValue="0"
						reduxCurrency={displayCurrency}
					/>
				</Text>
				<Text
					css={{
						color: '$grey12',
						fontWeight: '$bold',
						fontSize: '15px',
						lineHeight: '28px',
						'@lg': {
							fontSize: '16px',
							lineHeight: '28px',
						},
					}}
				>
					<DisplayPrice
						objectData={{ value: perPersonPrice }}
						path={'value'}
						defaultValue="0"
						reduxCurrency={displayCurrency}
					/>{' '}
					{'per person'}
				</Text>
			</Column>
			<Button
				primary
				onClick={onPress}
				disabled={currentResortCode}
				css={{
					color: '$white',
					fontWeight: '$extrabold',
					fontSize: '$2',
					borderRadius: '$1',
					boxShadow: 'none',
					border: 'none',
					height: '48px',
					padding: '14px 18px',
					lineHeight: '21px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					textAlign: 'center',
					'&:hover': {
						maxWidth: '100%',
						boxShadow: 'none',
						border: 'none',
						color: '$white',
					},
				}}
			>
				View Deal
			</Button>
		</Box>
	)
}
export default Pricecomponent
